$('.guide-hero__button').click(function () {
    $('.guide-hero__form').show();
    $('.guide-hero__info').hide();
});
$('.guide-favorite-tours__more').click(function (e) {
    e.preventDefault();
    $('.tour-card').show();
    $('.guide-favorite-tours__more').hide();
});


// WEBPACK FOOTER //
// ./scripts/modules/guide-page.js